import {QueryClient} from 'react-query'
import {QUERIES} from '../../../../../../_metronic/helpers'

export function invalidateContractsQueries(queryClient: QueryClient): void {
  queryClient.invalidateQueries({
    predicate: (query) => {
      const key = query.queryKey
      if (typeof key === 'string') {
        return key.startsWith(QUERIES.CONTRACTS_LIST)
      }
      if (Array.isArray(key) && typeof key[0] === 'string') {
        return key[0].startsWith(QUERIES.CONTRACTS_LIST)
      }
      return false
    },
  })
}
